import { Nft } from "@/api/nfts/types";

export const calculateDisplayedDimensions = (nft: Nft) => {
  const maxPortraitImageHeight = 800;
  const maxSquaredImageWidth = 540;

  const displayedDimensions = {
    displayedWidth: nft.imageWidth,
    displayedHeight: nft.imageHeight,
  };

  if (nft.imageWidth === nft.imageHeight) {
    if (nft.imageWidth > maxSquaredImageWidth) {
      displayedDimensions.displayedWidth = maxSquaredImageWidth;
      displayedDimensions.displayedHeight = maxSquaredImageWidth;
    }
  } else if (nft.imageWidth < nft.imageHeight) {
    if (nft.imageHeight > maxPortraitImageHeight) {
      displayedDimensions.displayedWidth =
        (maxPortraitImageHeight / nft.imageHeight) * nft.imageWidth;
      displayedDimensions.displayedHeight = maxPortraitImageHeight;
    }
  }

  return displayedDimensions;
};
